import { render, staticRenderFns } from "./feedbackDetailedInfo.vue?vue&type=template&id=6610cb32&"
import script from "./feedbackDetailedInfo.vue?vue&type=script&lang=js&"
export * from "./feedbackDetailedInfo.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetailedInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports